import { render } from "./TheFooter.vue?vue&type=template&id=2707a98c&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=2707a98c&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2707a98c"]])

export default __exports__